import axios from '@/service/interceptor';
import settings from '@/utils/settings';
import _ from 'lodash';

export default {
    getWebContent: _.debounce(
        () =>
            axios
                .get(`${settings.HOST}/bittrade/v2/me?cmd=webContentInfo`)
                .then(res => {
                    try {
                        const data = JSON.parse(res.data.data);
                        return Object.keys(data).reduce(
                            (acc, cur) => ({
                                ...acc,
                                [cur]:
                                    typeof data[cur] === 'string'
                                        ? JSON.parse(data[cur])
                                        : data[cur]
                            }),
                            {}
                        );
                    } catch (e) {
                        return {};
                    }
                }),
        1000,
        { leading: true, trailing: true }
    )
};



// WEBPACK FOOTER //
// ./src/utils/webcontent.js